import { ProgressSteps, Step } from 'baseui/progress-steps';
import { User } from '../../../types/users';
import { UserFormFields } from './UserFormFields';
import { UserScheduleFields } from './UserScheduleFields';
import { UserSkillFields } from './UserSkillFields';

type Props = {
  user?: User;
  additionalSteps?: JSX.Element[];
  currentStep: number;
};
export function UserFormSteps({
  currentStep,
  additionalSteps,
  user
}: Readonly<Props>) {
  
  const generalDataStep = (
    <Step title="Datos del usuario">
      <UserFormFields
        user={user}
      />
    </Step>
  );

  const scheduleStep = (
    <Step title="Horario">
      <UserScheduleFields />
    </Step>
  );

  const skillStep = (
    <Step title="Habilidades">
      <UserSkillFields />
    </Step>
  );

  const steps = [generalDataStep, scheduleStep, skillStep]

  if (additionalSteps) {
    steps.push(...additionalSteps);
  }

  return <ProgressSteps current={currentStep}>{steps}</ProgressSteps>;
}
